import { Component, OnInit } from '@angular/core';
import { ApiService } from '../service/api.service';
import { Constants } from '../constants/constants';
import { UtilService } from '../service/util.service';
import { AuthenticationService } from '../service/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../service/toast.service';

@Component({
  selector: 'app-service-packages',
  templateUrl: './service-packages.component.html',
  styleUrls: ['./service-packages.component.scss']
})
export class ServicePackagesComponent implements OnInit {

  servicePackages: Array<any> = new Array();
  connectedVehicles: number = 0;
  accountCategory: string;
  isViewScreen = false;
  selectedPkgForView = null;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private route: ActivatedRoute, private toast: ToastService) { }

  ngOnInit() {
    this.isViewScreen = false;
    this.accountCategory = this.apiService.accountDetail.category;
    this.route.queryParams.subscribe(params => {
      let vehicles = params["connectedVehicles"];
      if (vehicles) {
        this.connectedVehicles = vehicles;
      }
    });
    console.log("connectedVehicles::", this.connectedVehicles);
    // this.servicePackages = this.apiService.getAccountServicePackageList();
    this.getPackageList();
    console.log("service packages::", this.servicePackages);
  }

  updatePackageImportEntryTypes: any = ['QUICK_ENTRY', 'DETAILED_ENTRY'];
  selectedupdatePackageEntryType: string = "QUICK_ENTRY";
  selectedupdatePackageEntryFile: File = null;

  getPackageList() {
    this.utilService.showSpinner();
    this.apiService.getAccountServicePackageList().then((data) => {
      this.utilService.hideSpinner();
      this.servicePackages = data;
      console.log("service package from API::", this.servicePackages);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getPackageList();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onupdatePackageEntryTypeSelected() {
    console.log("updatePackage Entry Upload Type::", this.selectedupdatePackageEntryType);
  }

  onupdatePackageFileSelected(event: any) {
    this.selectedupdatePackageEntryFile = event.target.files[0];
  }

  uploadupdatePackageEntries() { }

  packageClickedForView(pkg) {
    this.isViewScreen = true;
    this.selectedPkgForView = JSON.parse(JSON.stringify(pkg));
  }

  submitButtonOfViewClicked(data) {

  }

  closeOfViewClicked(data) {
    this.isViewScreen = false;
  }
}
